export const columnsHeadingFontKeys = {
    md: ['Primary/20-120_-1', null, 'Primary/40_100_-2', null, 'Primary/60_100_-3'],
    lg: ['Primary/40_100_-2', null, 'Primary/60_100_-3', null, 'Primary/72_100_-3'],
};
